import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";

import AdminShell from "./components/AdminShell";
import AdminOperators from "./pages/AdminOperators";
import AboutPage from "./pages/AboutPage";
import Board from "./pages/Board";
import CookiesPage from "./pages/CookiesPage";
import InviteAccept from "./pages/InviteAccept";
import Join from "./pages/Join";
import Login from "./pages/Login";
import OrgDashboard from "./pages/OrgDashboard";
import OrgSessionList from "./pages/OrgSessionList";
import PrivacyPage from "./pages/PrivacyPage";
import SessionModerators from "./pages/SessionModerators";
import { AppFooter } from "./components/AppFooter";
import CookieBanner from "./components/CookieBanner";
import { ThemeToggle } from "./components/ThemeToggle";
import "./styles/timeback.css";
import "./styles.css";

// /sessions/:id/ask was the old separate composer page; the board now hosts
// the composer inline, so the old route redirects to keep stale QR codes /
// links working.
function AskRedirect() {
  const { sessionId } = useParams<{ sessionId: string }>();
  return <Navigate to={`/sessions/${sessionId}/board`} replace />;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeToggle />
      <Routes>
        <Route path="/" element={<Navigate to="/join" replace />} />
        <Route path="/join" element={<Join />} />
        <Route path="/sessions/:sessionId/ask" element={<AskRedirect />} />
        <Route path="/sessions/:sessionId/board" element={<Board />} />
        {/* Policy pages — public, no auth, no AdminShell. Linked from
            the footer on every page; also reachable directly from the
            cookie banner. */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        {/* Public invite-acceptance landing — no AdminShell wrapper because
            it's pre-OAuth (the unauthenticated invitee should see the
            preview before the sign-in CTA). */}
        <Route path="/invite/:token" element={<InviteAccept />} />
        {/* SaaS-mode sign-in page. Posts an email to the backend, which
            emails a one-tap link; the link lands on /api/v1/auth/verify
            (backend), which sets the session cookie and 303s to /admin.
            On verify failure the backend lands here with ?error=expired. */}
        <Route path="/login" element={<Login />} />
        {/* All /admin/* routes share the role-aware top nav from
            AdminShell. AdminShell reads /api/v1/admin/me once and exposes
            it via Outlet context for child routes. */}
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<OrgSessionList />} />
          <Route path="operators" element={<AdminOperators />} />
          <Route path="sessions" element={<OrgSessionList />} />
          <Route path="sessions/:sessionId" element={<OrgDashboard />} />
          <Route
            path="sessions/:sessionId/moderators"
            element={<SessionModerators />}
          />
        </Route>
      </Routes>
      <AppFooter />
      <CookieBanner />
    </BrowserRouter>
  </React.StrictMode>,
);
